import { RouterParams } from './interfaces/IRouter';

const continueMiddleware = ({ next, router }: RouterParams) => {
  return next();
};

export { continueMiddleware };
